import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShopSettingsService } from '../modules/general/services/shop-settings.service';

@Injectable()
export class PageRegistrationGuard implements CanActivate {

  constructor(
    private router: Router,
    private shopSettingsService: ShopSettingsService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.shopSettingsService.allowedRegistration) {
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
